// @flow

import * as React from 'react'

import {
  EditorInput,
  FormGroup,
} from '../../../../../infrastructure/components/Formik'
import { SpacingSettings } from '../shared'

const WebshopTextWidgetSettings = ({ values }) => {
  return (
    <div>
      <FormGroup>
        <EditorInput name="data.text" height={300} />
      </FormGroup>

      <SpacingSettings />
    </div>
  )
}

export default WebshopTextWidgetSettings
